/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { CriteriaWeightingResponse } from '../model/criteriaWeightingResponse';
// @ts-ignore
import { UpsertCriteriaWeightingRequest } from '../model/upsertCriteriaWeightingRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    EvaluationSubCriteriaWeightingControllerServiceInterface,
    GetEvaluationSubCriteriaWeightingRequestParams,
    UpsertEvaluationSubCriteriaWeightingRequestParams
} from './evaluationSubCriteriaWeightingController.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class EvaluationSubCriteriaWeightingControllerService extends BaseService implements EvaluationSubCriteriaWeightingControllerServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEvaluationSubCriteriaWeighting(requestParameters: GetEvaluationSubCriteriaWeightingRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CriteriaWeightingResponse>;
    public getEvaluationSubCriteriaWeighting(requestParameters: GetEvaluationSubCriteriaWeightingRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CriteriaWeightingResponse>>;
    public getEvaluationSubCriteriaWeighting(requestParameters: GetEvaluationSubCriteriaWeightingRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CriteriaWeightingResponse>>;
    public getEvaluationSubCriteriaWeighting(requestParameters: GetEvaluationSubCriteriaWeightingRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const projectId = requestParameters?.projectId;
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling getEvaluationSubCriteriaWeighting.');
        }
        const evaluationCriteriaId = requestParameters?.evaluationCriteriaId;
        if (evaluationCriteriaId === null || evaluationCriteriaId === undefined) {
            throw new Error('Required parameter evaluationCriteriaId was null or undefined when calling getEvaluationSubCriteriaWeighting.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/projects/${this.configuration.encodeParam({name: "projectId", value: projectId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/evaluation-subcriteria/${this.configuration.encodeParam({name: "evaluationCriteriaId", value: evaluationCriteriaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/weighting`;
        return this.httpClient.request<CriteriaWeightingResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public upsertEvaluationSubCriteriaWeighting(requestParameters: UpsertEvaluationSubCriteriaWeightingRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<CriteriaWeightingResponse>;
    public upsertEvaluationSubCriteriaWeighting(requestParameters: UpsertEvaluationSubCriteriaWeightingRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<CriteriaWeightingResponse>>;
    public upsertEvaluationSubCriteriaWeighting(requestParameters: UpsertEvaluationSubCriteriaWeightingRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<CriteriaWeightingResponse>>;
    public upsertEvaluationSubCriteriaWeighting(requestParameters: UpsertEvaluationSubCriteriaWeightingRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const projectId = requestParameters?.projectId;
        if (projectId === null || projectId === undefined) {
            throw new Error('Required parameter projectId was null or undefined when calling upsertEvaluationSubCriteriaWeighting.');
        }
        const evaluationCriteriaId = requestParameters?.evaluationCriteriaId;
        if (evaluationCriteriaId === null || evaluationCriteriaId === undefined) {
            throw new Error('Required parameter evaluationCriteriaId was null or undefined when calling upsertEvaluationSubCriteriaWeighting.');
        }
        const upsertCriteriaWeightingRequest = requestParameters?.upsertCriteriaWeightingRequest;
        if (upsertCriteriaWeightingRequest === null || upsertCriteriaWeightingRequest === undefined) {
            throw new Error('Required parameter upsertCriteriaWeightingRequest was null or undefined when calling upsertEvaluationSubCriteriaWeighting.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/projects/${this.configuration.encodeParam({name: "projectId", value: projectId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/evaluation-subcriteria/${this.configuration.encodeParam({name: "evaluationCriteriaId", value: evaluationCriteriaId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}/weighting`;
        return this.httpClient.request<CriteriaWeightingResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: upsertCriteriaWeightingRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
